import React from 'react';
import {
  DeleteOutlined as DeleteOutlineIcon,
  DownloadOutlined as DownloadOutlinedIcon,
  VisibilityOutlined as VisibilityOutlinedIcon,
} from '@mui/icons-material';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { appFormStyles } from '~/modules/guarantees/legacy/styles.ts';
import { CLIENT_STEP2_TEXT, clientDocumentActionMenuSlotProps } from '../constants.ts';
import type { TClientUploadDocumentRow } from '../types.ts';
import { buildClientDocumentMenuId } from '../utils.ts';

type TClientDocumentActionMenuProps = {
  anchorEl: HTMLElement | null;
  document: TClientUploadDocumentRow;
  isOpen: boolean;
  isDeleteDisabled: boolean;
  onClose: () => void;
  onDownload: (document: TClientUploadDocumentRow, forceDownload: boolean) => void;
  onDeleteUploadedDocument: (document: TClientUploadDocumentRow) => void;
};

const ClientDocumentActionMenu: React.FC<TClientDocumentActionMenuProps> = ({
  anchorEl,
  document,
  isOpen,
  isDeleteDisabled,
  onClose,
  onDownload,
  onDeleteUploadedDocument,
}) => (
  <Menu
    id={buildClientDocumentMenuId(document.id)}
    anchorEl={anchorEl}
    open={isOpen}
    onClose={onClose}
    disableScrollLock
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    slotProps={clientDocumentActionMenuSlotProps}
  >
    <MenuItem
      onClick={() => onDownload(document, false)}
      sx={appFormStyles.actionMenuItem}
    >
      <ListItemText primary={CLIENT_STEP2_TEXT.previewDocumentButton} />
      <ListItemIcon sx={appFormStyles.actionMenuItemIcon}>
        <VisibilityOutlinedIcon fontSize="small" />
      </ListItemIcon>
    </MenuItem>
    <MenuItem
      onClick={() => onDownload(document, true)}
      sx={appFormStyles.actionMenuItem}
    >
      <ListItemText primary={CLIENT_STEP2_TEXT.downloadDocumentButton} />
      <ListItemIcon sx={appFormStyles.actionMenuItemIcon}>
        <DownloadOutlinedIcon fontSize="small" />
      </ListItemIcon>
    </MenuItem>
    <MenuItem
      disabled={isDeleteDisabled || !document.applicationFileId}
      onClick={() => onDeleteUploadedDocument(document)}
      sx={appFormStyles.actionMenuItemDanger}
    >
      <ListItemText primary={CLIENT_STEP2_TEXT.deleteDocumentButton} />
      <ListItemIcon sx={appFormStyles.actionMenuItemDangerIcon}>
        <DeleteOutlineIcon fontSize="small" />
      </ListItemIcon>
    </MenuItem>
  </Menu>
);

export default ClientDocumentActionMenu;
